
import { LabelStyles, NewLabelExperience } from '@tableau/catalog-ui-temp';
import React from 'react';

import { CatalogProviders } from '~src/catalog/CatalogProviders';
import { showDMAwareness } from '~src/commonInfra/components/DMAwareness/DmAwarenessUtils';
import { DataLabelsPreviewDialog } from '~src/commonInfra/components/DMAwareness/LabelManagementPreview';
import { BrowserTitleService } from '~src/commonInfra/services/BrowserTitleService';
import { ConnectedExplorer } from '~src/spacesPlatform/components/Explorer/ConnectedExplorer';
import { ExplorerStyles } from '~src/spacesPlatform/components/Explorer/ExplorerStyles';
import { SpaceContainerStyles } from '~src/spacesPlatform/style/SpaceContainerStyles';

import { Messages } from '../../../codegen/Localize';

export interface AllLabelsSpaceOwnProps {
  readonly siteName: string;
}

export interface AllLabelsSpaceStateProps {
  readonly isBusyFetchingItems: boolean;
  readonly numberOfFetchedLabels: number;
}

export interface AllLabelsSpaceDispatchProps {
  readonly requestSpaceContents: () => void;
}

type AllLabelsSpaceProps = AllLabelsSpaceOwnProps & AllLabelsSpaceDispatchProps & AllLabelsSpaceStateProps

export function AllLabelsSpace({ siteName, requestSpaceContents }: AllLabelsSpaceProps) {
  React.useEffect(() => { BrowserTitleService.setTitleWithTranslatedSpace({ translatedSpaceName: Messages.labels() }); });

  React.useEffect(() => {
    requestSpaceContents();
  }, [siteName, requestSpaceContents]);

  if (showDMAwareness(true)){
    return (
    <div className={SpaceContainerStyles.SpaceContainer}>
      <div className={SpaceContainerStyles.MastheadArea}>
        <div className={ExplorerStyles.SpaceHeaderContent}>
          <div className={ExplorerStyles.SpaceHeaderText}>{Messages.labels()}</div>
        </div>
      </div>
      <div className={SpaceContainerStyles.SubplaceArea}>
        <DataLabelsPreviewDialog />
      </div>
    </div>
    );
  }

  return (
    <div className={SpaceContainerStyles.SpaceContainer}>
      <div className={SpaceContainerStyles.MastheadArea}>
        <div className={ExplorerStyles.SpaceHeaderContent}>
          <div className={ExplorerStyles.SpaceHeaderText}>{Messages.labels()}</div>
        </div>
        <div style={LabelStyles.SpaceHeader}>
          {Messages.labelManagementHeader()}
        </div>
      </div>

      <div className={SpaceContainerStyles.SubplaceArea}>
        <ConnectedExplorer
          supportedDisplayModes={['list']}
          toolbarProps={{
            supportFilterPanel: false,
            toolbarVisibility: 'enabled',
            hideSelection:true,
            toolbarContentSpecificControls: { beginning: <NewLabelButton onClose={() => requestSpaceContents()} /> }
          }}
          emptyStateProps={{
            primaryMessage: Messages.contentEmptyMessage()
          }}
        />
      </div>
    </div>
  );
}

function NewLabelButton({ onClose }: { readonly onClose: () => void }) {
  return (
    <CatalogProviders>
      <NewLabelExperience onClose={onClose} />
    </CatalogProviders>
  );
}
